export default class EventBusConstant {
  /**
   * 点击一对多vp，将事件模拟到vp下面的view
   */
  static EVENT_MOCK_VP_CLICK = "EVENT_MOCK_VP_CLICK"

  /**
   * 模拟按键事件
   */
  static EVENT_MOCK_ACTION = "EVENT_MOCK_ACTION"

  /**
   * 开启一个窗口fragment
   */
  static EVENT_START_WINDOW_FRAGMENT = "EVENT_START_WINDOW_FRAGMENT"

  /**
   * 移除一个窗口fragment
   */
  static EVENT_REMOVE_WINDOW_FRAGMENT = "EVENT_REMOVE_WINDOW_FRAGMENT"

  /**
   * 小窗口状态变化
   */
  static EVENT_MINIMIZE_WINDOW_CHANGE = "EVENT_MINIMIZE_WINDOW_CHANGE"

  /**
   * 加入声网房间成功
   * 加入成功之后在隐藏最外层滑动的图片
   */
  static EVENT_JOIN_AGORA_CHANNEL_SUCCESS = "EVENT_JOIN_AGORA_CHANNEL_SUCCESS"

  /**
   * 最小化直播间/语聊房
   * 方便其他module调用
   */
  static EVENT_MINIMIZE_LIME = "EVENT_MINIMIZE_LIME"

  /**
   * 最大化直播间/语聊房
   * 方便其他module调用
   */
  static EVENT_RESUME_MINIMIZE_LIME = "EVENT_RESUME_MINIMIZE_LIME"

  /**
   * 关闭直播间/语聊房
   * 方便其他module调用
   */
  static EVENT_CLOSE_LIME = "EVENT_CLOSE_LIME"

  /**
   * 网络状态改变
   */
  static EVENT_INTERNET_STATE_CHANGE = "EVENT_INTERNET_STATE_CHANGE"

  /**
   * 尝试打开直播间/语聊房
   * 任何位置都可以调用，但是只有在登录进入之后才生效
   */
  static EVENT_TRY_OPEN_LIME = "EVENT_TRY_OPEN_LIME"

  /**
   * 刷新房间列表
   */
  static EVENT_REFRESH_LIME_LIST = "EVENT_REFRESH_LIME_LIST"

  /**
   * 房间列表刷新回调
   */
  static EVENT_LIME_LIST_HAS_REFRESHED = "EVENT_LIME_LIST_HAS_REFRESHED"

  //*********************** 一对多 ***********************

  /**
   * 老视频聊天室关闭
   */
  static EVENT_LI_ME_VIDEO_CLOSE = "EVENT_LI_ME_VIDEO_CLOSE"

  /**
   * 新视频聊天室开启
   */
  static EVENT_LI_ME_VIDEO_CREATE = "EVENT_LI_ME_VIDEO_CREATE"

  /**
   * 视频聊天室恢复
   */
  static EVENT_LI_ME_VIDEO_RESUME = "EVENT_LI_ME_VIDEO_RESUME"

  /**
   * 视频聊天室解散
   */
  static EVENT_LI_ME_VIDEO_DESTROY = "EVENT_LI_ME_VIDEO_DESTROY"

  /**
   * 视频聊天室主持人被带走
   */
  static EVENT_LI_ME_VIDEO_HOST_IS_TAKEN = "EVENT_LI_ME_VIDEO_HOST_IS_TAKEN"

  /**
   * 视频聊天室私聊开关变化
   */
  static EVENT_LI_ME_VIDEO_PRIVATE_FLAG_CHANGE = "EVENT_LI_ME_VIDEO_PRIVATE_FLAG_CHANGE"


  //*********************** 语聊房 ***********************

  /**
   * 语聊房间解散
   */
  static EVENT_LI_ME_MULTI_DESTROY = "EVENT_LI_ME_MULTI_DESTROY"

  /**
   * 收到语聊房新建
   */
  static EVENT_LI_ME_MULTI_CREATE = "EVENT_LI_ME_MULTI_CREATE"

  /**
   * 收到语聊房关闭
   */
  static EVENT_LI_ME_MULTI_CLOSE = "EVENT_LI_ME_MULTI_CLOSE"

  /**
   * 加入房间
   */
  static EVENT_MULTI_JOIN_ROOM = "EVENT_MULTI_JOIN_ROOM"

  /**
   * 申请当boss
   */
  static EVENT_APPLY_TO_BE_BOSS = "EVENT_APPLY_TO_BE_BOSS"

  /**
   * 收到主播上麦
   */
  static EVENT_ANCHOR_PUT_ON_MIC = "EVENT_ANCHOR_PUT_ON_MIC"

  /**
   * 收到主播下麦
   */
  static EVENT_ANCHOR_PUT_OFF_MIC = "EVENT_ANCHOR_PUT_OFF_MIC"

  /**
   * 收到文字消息
   */
  static EVENT_RECEIVE_TEXT_MSG = "EVENT_RECEIVE_TEXT_MSG"

  /**
   * 收到语聊房人数变化
   */
  static EVENT_MULTI_MEMBER_UPDATE = "EVENT_MULTI_MEMBER_UPDATE"

  /**
   * 收到老板上麦
   */
  static EVENT_BOSS_PUT_ON_MIC = "EVENT_BOSS_PUT_ON_MIC"

  /**
   * 收到老板下麦
   */
  static EVENT_BOSS_PUT_OFF_MIC = "EVENT_BOSS_PUT_OFF_MIC"

  /**
   * 收到老板计费
   */
  static EVENT_BOSS_BILLING = "EVENT_BOSS_BILLING"

  /**
   * 收到提醒boss充值
   */
  static EVENT_REMIND_BOSS_RECHARGE = "EVENT_REMIND_BOSS_RECHARGE"

  /**
   * 主持人强制boss下麦
   */
  static EVENT_FORCE_BOSS_PUT_OFF_MIC = "EVENT_FORCE_BOSS_PUT_OFF_MIC"

  /**
   * 收到主持人禁言主播, boss
   */
  static EVENT_HOST_BAN_ANCHOR_BOSS = "EVENT_HOST_BAN_ANCHOR_BOSS"

  /**
   * 主持人解禁主播, boss
   */
  static EVENT_HOST_UNBAN_ANCHOR_BOSS = "EVENT_HOST_UNBAN_ANCHOR_BOSS"

  /**
   * 收到主持人编辑房间
   */
  static EVENT_HOST_EDIT_ROOM = "EVENT_HOST_EDIT_ROOM"

  /**
   * 收到主播上麦300秒倒计时结束
   */
  static EVENT_ANCHOR_ON_MIC_TIME_UP = "EVENT_ANCHOR_ON_MIC_TIME_UP"

  /**
   * 收到主持人禁止成员发文字消息
   */
  static EVENT_MULTI_BAN_TEXT_MSG = "EVENT_MULTI_BAN_TEXT_MSG"

  /**
   * 房间底部剩余的高度
   */
  static ROOM_BOTTOM_LEFT_HEIGHT = "ROOM_BOTTOM_LEFT_HEIGHT"

  /**
   * 消息未读数的跟新
   */
  static EVENT_TOTALUNREAD = "EVENT_TOTALUNREAD "

  /**
   * AppsFlyer回调
   */
  static EVENT_APPSFLYERCALLBACK = "EVENT_APPSFLYERCALLBACK"

  /**
   * AppsFlyer回调
   * 粘性事件
   */
  static EVENT_APPSFLYERCALLBACK_STICKY = "EVENT_APPSFLYERCALLBACK_STICKY"

  /**
   * 金币数变化
   */
  static EVENT_COIN_CHANGE = "EVENT_COIN_CHANGE"

  /**
   * google充值数变化
   */
  static EVENT_GOOGLE_RECHARGE_AMOUNT_CHANGE = "EVENT_GOOGLE_RECHARGE_AMOUNT_CHANGE"

  /**
   * 收到配对成功
   */
  static EVENT_MULTI_PERFECT_MATCH = "EVENT_MULTI_PERFECT_MATCH"

  /**
   * 收到用户带走主播
   */
  static EVENT_MULTI_TAKE_ANCHOR = "EVENT_MULTI_TAKE_ANCHOR"

  /**
   * 主播麦位倒计时改变
   */
  static EVENT_ANCHOR_ON_MIC_TIME_UPDATE = "EVENT_ANCHOR_ON_MIC_TIME_UPDATE"


  /**
   * 目标数据更新
   */
  static EVENT_UPDATE_ROOMGOL = "EVENT_UPDATE_ROOMGOL"

  /**
   * 目标完成
   */
  static EVENT_DONE_ROOMGOL = "EVENT_DONE_ROOMGOL"

  /**
   * 收到通话计费
   */
  static EVENT_CALL_BILLING = "EVENT_CALL_BILLING"

  /**
   * 收到挂电话
   */
  static EVENT_HUNG_UP = "EVENT_HUNG_UP"
  static EVENT_HUNG_UP_CALL = "EVENT_HUNG_UP"

  /**
   * 收到通话时间不足，提醒充值
   */
  static EVENT_REMIND_RECHARGE = "EVENT_REMIND_RECHARGE"

  /**
   *
   */
  static EVENT_USER_CALL = "EVENT_USER_CALL"

  static EVENT_ANCHOR_REFUSE_CALL = "EVENT_ANCHOR_REFUSE_CALL"

  static EVENT_USER_ENTER_ROOM = "EVENT_USER_ENTER_ROOM"

  /**
   * 错误的房间
   */
  static EVENT_ERROR_LIME_ROOM = "EVENT_ERROR_LIME_ROOM"

  /**
   * 收到hunting
   */
  static EVENT_RECEIVE_HUNT = "EVENT_RECEIVE_HUNT"

  /**
   * 收到停止hunting
   */
  static EVENT_RECEIVE_STOP_HUNT = "EVENT_RECEIVE_STOP_HUNT"

  /**
   * 主播主动呼叫的电话过程中提醒用户充值
   */
  static EVENT_RECEIVE_REMIND_HUNT_RECHARGE = "EVENT_RECEIVE_REMIND_HUNT_RECHARGE"

  /**
   * 点击详情页图片，切换大图
   */
  static EVENT_CLICK_DETAIL_PIC = "EVENT_CLICK_DETAIL_PIC"

  /**
   * 详情页查看大图状态改变
   */
  static EVENT_DETAIL_BIG_PIC_CHANGE = "EVENT_DETAIL_BIG_PIC_CHANGE"

  /**
   *  清空全部未读会话
   */
  static EVENT_CLICK_CLEAR_ALL_MESSAGE = "EVENT_CLICK_CLEAR_ALL_MESSAGE"

  /**
   *  选中全部未读会话
   */
  static EVENT_CLICK_CHOSE_ALL_MESSAGE = "EVENT_CLICK_CHOSE_ALL_MESSAGE"


  /**
   * 通知语聊房开关状态变化
   */
  static EVENT_NOTIFY_MULTI_OPEN_STATE = "EVENT_NOTIFY_MULTI_OPEN_STATE"


  //********************* pk *********************

  /**
   * PK匹配成功
   */
  static EVENT_PK_MATCH_SUCCESS = "EVENT_PK_MATCH_SUCCESS"

  /**
   * pk结束
   */
  static EVENT_PK_END = "EVENT_PK_END"

  /**
   * 收到PK比分更新
   */
  static EVENT_PK_POINT_UPDATE = "EVENT_PK_POINT_UPDATE"

  /**
   * pk倒计时结束
   */
  static EVENT_PK_TIME_UP = "EVENT_PK_TIME_UP"

  /**
   * 收到房主rtm推送PK再次邀请
   */
  static EVENT_PK_PLAY_AGAIN_RTM = "EVENT_PK_PLAY_AGAIN_RTM"

  /**
   * 收到PK对手逃跑
   */
  static EVENT_PK_RECEIVE_RUN_AWAY = "EVENT_PK_RECEIVE_RUN_AWAY"


  /**
   * 账号被挤下线
   */
  static EVENT_KICKEDOUT = "EVENT_KICKEDOUT"


  /**
   * 购买订阅成功
   */
  static EVENT_BUY_SUB = "EVENT_BUY_SUB"


  /**
   *  收到增加钻石
   */
  static EVENT_ADD_DIAMOND = "EVENT_ADD_DIAMOND"

  //语聊房收到警告消息
  static EVENT_RECIVE_HOST_WARN = "EVENT_RECIVE_HOST_WARN"


  //收到需要显示引导删除消息
  static EVENT_RECIVE_DELETE_GUIDE_MSG = "EVENT_RECIVE_DELETE_GUIDE_MSG"

  /**
   * 首页底部tab切换
   */
  static EVENT_CHANGE_HOME_TAB = "EVENT_CHANGE_HOME_TAB"


  /**
   * 视频秀信息改变
   */
  static EVENT_SPX_CHANGE = "EVENT_SPX_CHANGE"


  /**
   * 视频秀观看位子
   */
  static EVENT_SPX_WATCHPOS = "EVENT_SPX_WTACH_POS"


  /**
   * 关注信息改变
   */
  static EVENT_Follow_CHANGE = "EVENT_Follow_CHANGE"

  /**
   * HUNT打电话倒计时
   */
  static EVENT_HUNTCALL_TIME = "EVENT_HUNTCALL_TIME"

  /**
   * 排行榜初始化布局
   */
  static EVENT_PHB_INIT_POS = "EVENT_PHB_INIT_POS"

  /**
   * 刷新未读消息数量
   */
  static REFRESH_UNREAD_MSG_COUNT = "REFRESH_UNREAD_MSG_COUNT"

  /**
   * 禁止录屏
   */
  static EVENT_OPEN_SECURE = "EVENT_OPEN_SECURE"

  /**
   * 取消禁止录屏
   */
  static EVENT_CLOSE_SECURE = "EVENT_CLOSE_SECURE"

  static EVENT_HIDE_PRIVATE_CALL_DIALOG = "EVENT_HIDE_PRIVATE_CALL_DIALOG"

  /**
   * 取消等待通话请求结果等待
   */
  static EVENT_CLEAR_CALL_RESULT_TIMER = "EVENT_CLEAR_CALL_RESULT_TIMER"
  /**
   * 刷新主播详情
   * @type {string}
   */
  static EVENT_REFRESH_ANCHOR = "EVENT_REFRESH_ANCHOR"

  /**
   * 执行请求视频通话
   * @type {string}
   */
  static EVENT_DO_REQUEST_CALL = "EVENT_DO_REQUEST_CALL"

  /**
   * 游客充值后强制进入绑定流程
   * @type {string}
   */
  static EVENT_TO_BIND_AFR = "EVENT_TO_BIND_AFR"

  /**
   * 更新聊天消息
   */
  static EVENT_REFRESH_LC_CHAT = "EVENT_REFRESH_LC_CHAT"
  /**
   * 全部标记已读
   */
  static EVENT_REFRESH_LC_READ_ALL = "EVENT_REFRESH_LC_READ_ALL"
  /**
   * 未读消息总数
   */
  static EVENT_REFRESH_UNREAD_COUNT = "EVENT_REFRESH_UNREAD_COUNT"

  /**
   * 跳转活动页面
   * @type {string}
   */
  static EVENT_TO_ACT_PAGE = "EVENT_TO_ACT_PAGE"

  /**
   * 显示充值弹窗
   *
   */
  static EVENT_SHOW_RECHARGE_DIALOG = "EVENT_SHOW_RECHARGE_DIALOG"
  /**
   * 选择具体充值项充值
   * @type {string}
   */
  static EVENT_RECHARGE_PAY = "EVENT_RECHARGE_PAY"
  /**
   * 显示拉黑举报界面
   * @type {string}
   */
  static EVENT_REPORT_BLOCK = 'EVENT_REPORT_BLOCK'
  static EVENT_REPORT_BLOCK_HIDE = 'EVENT_REPORT_BLOCK_HIDE'

  /**
   * 显示活动页
   * @type {string}
   */
  static EVENT_SHOW_HC = "EVENT_SHOW_HC"
  static EVENT_HIDE_HC = "EVENT_HIDE_HC"

  /**
   * 刷新banner
   * @type {string}
   */
  static EVENT_BANNER_REFRESH = "EVENT_BANNER_REFRESH"
  /**
   * 自动播放失败展示弹窗
   * @type {string}
   */
  static EVENT_AUTO_PLAY = "EVENT_AUTO_PLAY"


  /**
   * 首页占位图
   * @type {string}
   */
  static EVENT_HIDE_HOLDER_IN_HOME = "EVENT_HIDE_HOLDER_IN_HOME"

  /**
   * 聊天室对象刷新
   */
  static EVENT_CHAT_ROOM_REFRESH = "EVENT_CHAT_ROOM_REFRESH"

  /**
   * 显示语聊房引导
   * @type {string}
   */
  static EVENT_SHOW_VCR_GUIDE = "EVENT_SHOW_VCR_GUIDE"
  static EVENT_HIDE_VCR_GUIDE = "EVENT_HIDE_VCR_GUIDE"

  /**
   * 挂断电话
   * @type {string}
   */
  static EVENT_DO_STOP_CALL = "EVENT_DO_STOP_CALL"

  /**
   * 刷新房间列表
   * @type {string}
   */
  static EVENT_REFRESH_ROOM_LIST = "EVENT_REFRESH_ROOM_LIST"

  static EVENT_DO_MOMENT_SAYHI = "EVENT_DO_MOMENT_SAYHI"
  static EVENT_SHOW_MOMENT_SAYHI = "EVENT_SHOW_MOMENT_SAYHI"
  static EVENT_REFRESH_MINE_MOM_COUNT = "EVENT_REFRESH_MINE_MOM_COUNT"
  static EVENT_MOMENT_REPORT_DEL = "EVENT_MOMENT_REPORT_DEL"

  /**
   * 显示大图相册
   * @type {string}
   */
  static EVENT_SHOW_PHOTO_GALLERY = "EVENT_SHOW_PHOTO_GALLERY"

  static EVENT_NET_RECONNECT = "EVENT_NET_RECONNECT"

  static EVENT_SHOW_VIDEO = "EVENT_SHOW_VIDEO"
  static EVENT_HIDE_VIDEO = "EVENT_HIDE_VIDEO"


  static EVENT_SHOW_GAME_DIALOG = "EVENT_SHOW_GAME_DIALOG"

  static EVENT_SHOW_ROOM_TOOL_DIALOG = "EVENT_SHOW_ROOM_TOOL_DIALOG"

  /**
   * 入场动画
   * @type {string}
   */
  static EVENT_ENTER_EFFECT = 'EVENT_ENTER_EFFECT'

  /**
   * 显示挂断评价弹窗
   * @type {string}
   */
  static EVENT_SHOW_CALL_END = "EVENT_SHOW_CALL_END"

  /**
   * 展示登录绑定弹窗
   * @type {string}
   */
  static EVENT_SHOW_LOG_REG="EVENT_SHOW_LOG_REG"

  static EVENT_WEB_PAY_AVAILABLE="EVENT_WEB_PAY_AVAILABLE"

  static EVENT_IAP_PAY_SUCCESS="EVENT_IAP_PAY_SUCCESS"
}



// WEBPACK FOOTER //
// ./src/push/const/EventBusConstant.js